import { makeStyles } from "@material-ui/core/styles";
import PDFIcon from "../../../assets/icons/PDF.svg";
import DOCIcon from "../../../assets/icons/DOC.svg";
import DOCXIcon from "../../../assets/icons/DOCX.svg";
import JPGIcon from "../../../assets/icons/JPG.svg";
import PNGIcon from "../../../assets/icons/PNG.svg";
import TIFIcon from "../../../assets/icons/TIF.svg";
import XLSIcon from "../../../assets/icons/XLS.svg";
import CloseIcon from "../../../assets/icons/close.png";

const getPreviewIcon = (type) => {
  const fileType = type?.split("/").pop();

  switch (fileType) {
    case "pdf":
      return PDFIcon;
    case "doc":
      return DOCXIcon;
    case "docx":
      return DOCXIcon;
    case "jpeg":
    case "jpg":
      return JPGIcon;
    case "png":
      return PNGIcon;
    case "tiff":
      return TIFIcon;
    case "xls":
      return XLSIcon;
    default:
      return DOCIcon;
  }
};

const useStyles = makeStyles((theme) => ({
  previewContainer: {
    marginTop: theme.spacing(2),
    display: "flex",
    height: "auto",
    width: "95%",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "0.8rem",
    },
    "& img": {
      width: "3rem",
      opacity: "0.5",
      [theme.breakpoints.down("sm")]: {
        width: "1.75rem",
      },
    },
    "& .container": {
      height: "2.9rem",
      width: "100%",
      display: "flex",
      flexGrow: "1",
      "& .details": {
        width: "100%",
        "& label": {
          width: "95%",
          marginLeft: "0.2rem",
          overflow: "hidden",
          opacity: "0.8",
          color: theme.palette.primary.dark,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          position: "absolute",
          [theme.breakpoints.up("md")]: {
            fontSize: "1.2rem",
          },
          [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
            width: "85%",
            marginLeft: "0",
          },
        },
        "& .close": {
          float: "right",
          marginTop: "0.4rem",
          backgroundImage: "url(" + CloseIcon + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          opacity: "0.5",
          cursor: "pointer",
          width: "1rem",
          height: "1rem",
          [theme.breakpoints.down("sm")]: {
            width: "0.8rem",
            height: "0.8rem",
          },
        },
      },
      [theme.breakpoints.down("sm")]: {
        height: "2rem",
        marginLeft: theme.spacing(0.8),
      },
      [theme.breakpoints.up("md")]: {
        position: "relative",
        marginLeft: theme.spacing(1),
      },
    },
    "& .progress": {
      width: "100%",
      height: "1rem",
      border: "1px solid lightgrey",
      overflow: "hidden",
      "& .inner": {
        backgroundColor: theme.palette.background.dark,
        opacity: "0.5",
        height: "100%",
        "&.preparing": {
          width: "90%",
          animation: "load 2s linear 0s infinite",
          animationIterationCount: "1",
        },
        "&.done": {
          width: "100%",
          animation: "finish 1s linear 0s infinite",
          animationIterationCount: "1",
        },
        "&.complete": {
          width: "100%",
        },
      },
      [theme.breakpoints.up("md")]: {
        position: "absolute",
        left: "0",
        bottom: "0",
      },
      [theme.breakpoints.down("sm")]: {
        position: "absolute",
        left: "0",
        bottom: "-0.8rem",
      },
    },
  },
}));

const CustomPreview = (props) => {
  const { meta, fileWithMeta } = props;
  const classes = useStyles();
  const isUploaded = !(fileWithMeta.file instanceof File);

  const icon = getPreviewIcon(meta?.type);

  return (
    <div className={classes.previewContainer}>
      <img src={icon} alt={meta?.name} />

      <div className="container">
        <div className="details">
          <label>{meta?.name}</label>
          <div className="close" onClick={() => fileWithMeta.remove()} />
        </div>
        <div className="progress">
          <div className={"inner " + (isUploaded ? "complete" : meta.status)} />
        </div>
      </div>
    </div>
  );
};

export default CustomPreview;
